import type { PageSerpSnapshot } from './api-types';
import { resolveCompareTargets } from './compare-target';

export interface TopSerpRivalPick {
  url: string;
  domain: string;
  /** Why earlier SERP rows were skipped (homepage / login / app-shell), if any. */
  skippedNote?: string | null;
}

/**
 * The playbook's Quick Compare target, resolved by `compare-target.ts` — the
 * same rules the backend crawls with and the review's Compare row names.
 *
 * This used to carry its own copy of the guards, and it was missing one: it
 * never checked that the row actually beats you, so on a page ranking #2 it
 * would offer a compare against a #4 result while the backend had crawled
 * nothing, and the step opened onto a page we hold no analysis for.
 */
export function findTopSerpRival(
  pageSerp: PageSerpSnapshot | null,
  selfDomain: string
): TopSerpRivalPick | null {
  const { targets, skippedNote } = resolveCompareTargets({
    results: pageSerp?.results || [],
    selfDomain,
    yourPosition: pageSerp?.yourPosition ?? null
  });
  const best = targets.find((t) => t.kind === 'serp_winner');
  if (!best) return null;
  return { url: best.url, domain: best.domain, skippedNote };
}
